import {
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  Dimensions,
} from "react-native";
import React, { useState } from "react";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";

import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import FleetManagerActive from "./FleetManagerActive";
import FleetManagerHistory from "./FleetManagerHistory";

const Tab = createMaterialTopTabNavigator();
const { width } = Dimensions.get("window");

// Custom Tab Component
const CustomTabBar = ({ state, descriptors, navigation }) => {
  const [tabWidth, setTabWidth] = useState(0);

  return (
    <View style={styles.tabContainer}>
      <View style={styles.tabBackground}>
        {state.routes.map((route, index) => {
          const { options } = descriptors[route.key];
          const label = options.tabBarLabel || options.title || route.name;
          const isFocused = state.index === index;

          const onPress = () => {
            const event = navigation.emit({
              type: "tabPress",
              target: route.key,
              canPreventDefault: true,
            });

            if (!isFocused && !event.defaultPrevented) {
              navigation.navigate(route.name);
            }
          };

          const onLayout = (event) => {
            const { width } = event.nativeEvent.layout;
            setTabWidth(width / state.routes.length);
          };

          return (
            <TouchableOpacity
              key={route.key}
              onPress={onPress}
              onLayout={onLayout}
              style={[
                styles.tabButton,
                isFocused && styles.activeTabButton,
                { width: (width - 40) / state.routes.length },
              ]}
              activeOpacity={0.7}
            >
              <View style={styles.tabContent}>
                {isFocused && <View style={styles.activeIndicator} />}
                <Text
                  style={[styles.tabText, isFocused && styles.activeTabText]}
                >
                  {label}
                </Text>
              </View>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};

const FleetManager = ({ navigation }) => {
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.sandal }}>
      {/* Header */}
      <View style={styles.header}>
        <View style={styles.headerLeft}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image source={AppImages.Backbtn} style={styles.backIcon} />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>Fleet Manager</Text>
        </View>
        <View style={styles.headerRight}>
          <TouchableOpacity
            onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}
            style={styles.iconButton}
          >
            <Image
              source={AppImages.Bellnoti}
              style={styles.notificationIcon}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => navigation.navigate("AddFleetManager")}
            style={[styles.iconButton, { marginLeft: 20 }]}
          >
            <Image
              source={AppImages.Plus}
              style={styles.plusIcon}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>

      {/* Custom Tabs */}
      <View style={styles.tabWrapper}>
        <CustomTabBar
          state={{
            index: 0,
            routes: [
              { key: "active", name: "Active" },
              { key: "history", name: "History" },
            ],
          }}
          descriptors={{
            active: {
              options: { tabBarLabel: "Active" },
            },
            history: {
              options: { tabBarLabel: "History" },
            },
          }}
          navigation={navigation}
        />

        {/* Tab Content */}
        <View style={styles.contentContainer}>
          {/* You can switch between components based on state */}
          <FleetManagerActive />
          {/* Or use Tab.Navigator with custom tabBar */}
          {/* <Tab.Navigator tabBar={props => <CustomTabBar {...props} />}>
            <Tab.Screen name="Active" component={FleetManagerActive} />
            <Tab.Screen name="History" component={FleetManagerHistory} />
          </Tab.Navigator> */}
        </View>
      </View>
    </SafeAreaView>
  );
};

// Alternative: If you want to use with Tab.Navigator
const CustomTabNavigator = () => {
  return (
    <Tab.Navigator
      tabBar={(props) => <CustomTabBar {...props} />}
      screenOptions={{
        swipeEnabled: true,
      }}
    >
      <Tab.Screen
        name="Active"
        component={FleetManagerActive}
        options={{ tabBarLabel: "Active" }}
      />
      <Tab.Screen
        name="History"
        component={FleetManagerHistory}
        options={{ tabBarLabel: "History" }}
      />
    </Tab.Navigator>
  );
};

export default FleetManager;

const styles = StyleSheet.create({
  // Header Styles
  header: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: AppColors.white,
    height: 58,
    justifyContent: "space-between",
    paddingHorizontal: 20,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 5,
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerRight: {
    flexDirection: "row",
    alignItems: "center",
  },
  backButton: {
    height: 30,
    width: 30,
    justifyContent: "center",
  },
  backIcon: {
    width: 8,
    height: 15,
  },
  headerTitle: {
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
    marginLeft: 12,
  },
  iconButton: {
    padding: 5,
  },
  notificationIcon: {
    width: 16,
    height: 20,
  },
  plusIcon: {
    width: 18,
    height: 18,
  },

  // Tab Styles
  tabWrapper: {
    flex: 1,
    marginTop: 20,
  },
  tabContainer: {
    paddingHorizontal: 20,
    marginBottom: 10,
  },
  tabBackground: {
    flexDirection: "row",
    backgroundColor: AppColors.white,
    borderRadius: 12,
    padding: 4,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  tabButton: {
    height: 45,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 10,
  },
  activeTabButton: {
    backgroundColor: "#FFF8F2",
  },
  tabContent: {
    alignItems: "center",
    justifyContent: "center",
  },
  activeIndicator: {
    position: "absolute",
    top: -4,
    width: 40,
    height: 3,
    backgroundColor: "#8F4300",
    borderRadius: 2,
  },
  tabText: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    color: "#9C4900CC",
  },
  activeTabText: {
    fontFamily: AppFonts.OverpassBold,
    color: "#8F4300",
  },
  contentContainer: {
    flex: 1,
    paddingHorizontal: 20,
  },
});
